import React from 'react'
import { Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer'
import LatoRegular from '../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import MindsetImg from "../../../Assets/Images/Mindset-1.png";
import MindsetFixed from "../../../Assets/Images/MindsetFixed.png";

Font.register({
    family: 'Lato',
    fonts: [
        { src: LatoRegular, fontWeight: 400 },
        { src: LatoBold, fontWeight: 700 }
    ]
});

const styles = StyleSheet.create({
    imageContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20
    },
    imageSmall: {
        width: '251px'
    },
    imageLarge: {
        width: '533px',
        marginTop: 10
    },
    // sectionTitle: {
    //     fontFamily: 'Lato',
    //     fontWeight: 700,
    //     fontSize: '16px',
    //     color: '#426B88',
    //     marginTop: 20,
    //     textAlign: 'center'
    // }
});

const MindsetImagePage = ({ apiData }) => {
    return (
            <View style={styles.imageContainer}>
                <Image src={MindsetImg} style={styles.imageSmall} />
                <Image src={MindsetFixed} style={styles.imageLarge} />
            </View>
    )
}

export default MindsetImagePage;
